import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cc00c672"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cm-align-center" }
const _hoisted_2 = { class: "terminal-info-ul" }
const _hoisted_3 = {
  class: "cm-align-center",
  style: {"line-height":"12px"}
}
const _hoisted_4 = {
  key: 0,
  class: "terminal-info-ul"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "auth-popover-ul gap-5" }
const _hoisted_7 = { class: "cm-ui-mb15 cm-align-center" }
const _hoisted_8 = { class: "copy-button-icon-wrap" }
const _hoisted_9 = {
  key: "copy",
  class: "icon",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  "aria-hidden": "true"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M85.333333 170.666667a85.333333 85.333333 0 0 1 85.333334-85.333334h426.666666a85.333333 85.333333 0 0 1 85.333334 85.333334v170.666666h170.666666a85.333333 85.333333 0 0 1 85.333334 85.333334v426.666666a85.333333 85.333333 0 0 1-85.333334 85.333334H426.666667a85.333333 85.333333 0 0 1-85.333334-85.333334v-170.666666H170.666667a85.333333 85.333333 0 0 1-85.333334-85.333334V170.666667z m341.333334 512v170.666666h426.666666V426.666667h-170.666666v170.666666a85.333333 85.333333 0 0 1-85.333334 85.333334h-170.666666z m170.666666-85.333334V170.666667H170.666667v426.666666h426.666666z",
  fill: "var(--el-color-primary)"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: "check",
  class: "icon icon-check",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  "aria-hidden": "true"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M822.464 265.344a28.256 28.256 0 0 0-43.072 1.312l-352.96 417.664-181.92-212.992a28.288 28.288 0 0 0-43.104-1.088 37.12 37.12 0 0 0-0.96 48.256l204.096 238.944c5.76 6.752 13.696 10.56 22.016 10.56h0.096a29.088 29.088 0 0 0 22.048-10.656L823.68 313.6c11.52-13.728 11.008-35.328-1.216-48.256",
  fill: "var(--el-color-primary)"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "cm-align-center access-code-actions cm-ui-pt15" }

import { computed, onMounted, onUnmounted, reactive, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ElMessage, ElMessageBox } from 'element-plus'
import CmTable from '@/components/cmTable/index.vue'
import { TableOpt } from '@/components/cmTable/types'
import Card from '@/views/dashboard/_components/card/card.vue'
import { useCopy } from '@/utils'
import { handleDataToTree } from '@/utils/tool'
import { CascadeService, TeamTerminal } from '@/views/dashboard/cascade-center/cascade-manage/service'
import { AuthLabel, authMode, terminalInfo } from '@/views/dashboard/cascade-center/cascade-manage/types'
import { PermissionsText, PermissionsState } from '@/views/dashboard/cascade-center/approval/types'
import { team, user } from '@/common/basis/root-injector'
import { CascadeLoginService } from '@/services/cascade-login.service'

type RowAction = TeamTerminal & { permissions?: string[]; access_code?: string }

const COPY_ACCESS_SUCCESS_MS = 2000

export default /*#__PURE__*/_defineComponent({
  __name: 'cascade-lower-branches-block',
  props: {
  title: { type: String, default: '' }
},
  emits: ["refreshed"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const { t } = useI18n()
const router = useRouter()
const injector = useReflectiveInjector([CascadeService, CascadeLoginService])
const cascadeService = injector.get(CascadeService)
const cascadeLoginService = injector.get(CascadeLoginService)

const queryStub = reactive({})
const tableRef = ref()
const loadingTreeData = ref(false)
const treeData = ref<any[]>([])
const accessVisible = ref(false)
const accessCode = ref('')

const unit = computed(() => t('cascadeBranchOverview.terminalUnit'))
const getAccessKeyText = computed(() => t('cascadeBranchOverview.getAccessKey'))
const accessKeyTooltip = computed(() => t('cascadeBranchOverview.accessKeyTooltip'))
const authDetailTooltip = computed(() => t('cascadeBranchOverview.authDetailTooltip'))
const copyHint = computed(() => t('cascadeBranchOverview.copyAccessHint'))
const regenerateAccessKeyText = computed(() => t('cascadeBranchOverview.regenerateAccessKey'))

const copyAccessSuccess = ref(false)
let copyAccessSuccessTimer: ReturnType<typeof setTimeout> | null = null

const copyTooltipContent = computed(() =>
  copyAccessSuccess.value ? t('rawDataDrawer.copied') : copyHint.value
)

const refreshAccessLoading = ref(false)

const tableOpt = reactive<TableOpt>({
  'tree-props': { children: 'children', hasChildren: 'hasChildren' },
  'default-expand-all': true,
  bodyStyle: 'padding: 0',
  showActionBar: false,
  hiddenPageTool: true,
  showForm: true,
  showRightToolbar: false,
  height: '480px',
  showTip: false,
  rowKey: 'team_id',
  selection: false,
  path: 'datas',
  columns: [
    { label: t('cascadeBranchOverview.colName'), prop: 'name', width: 230 },
    { label: t('cascadeBranchOverview.colIp'), prop: 'child_ip_addr', width: 180 },
    { label: t('cascadeBranchOverview.colPort'), prop: 'child_server_port', width: 120 },
    { label: t('cascadeBranchOverview.colDeployed'), prop: 'terminalInfo', width: 240 },
    {
      label: t('cascadeBranchOverview.colAuthMode'),
      prop: 'permission_type',
      width: 130,
      formatter: (row, value) =>
        AuthLabel[(value ?? (row as { auth_type?: authMode }).auth_type) as authMode] ?? '--'
    },
    { label: t('cascadeBranchOverview.colAuthDetail'), prop: 'auth_service_infos', width: 240 },
    {
      label: t('cascadeBranchOverview.colPermissions'),
      prop: 'permissions',
      formatter: (_row, val: string[] = []) =>
        val.length ? val.map(v => PermissionsText[v as PermissionsState]).join('、') : '--'
    }
  ]
})

const tableActOpt = reactive({
  isLink: true,
  height: '100%',
  columnOpt: { label: t('cascadeBranchOverview.colOperation'), width: 140, align: 'left' },
  actionButtons: (row: RowAction) => {
    const permissions = row.permissions || []
    return [
      {
        name: t('cascadeBranchOverview.edit'),
        type: 'edit',
        opt: { size: 'small', type: 'text' as const }
      },
      {
        name: t('cascadeBranchOverview.login'),
        type: 'login',
        disabledTooltip: permissions.includes(PermissionsState.Password_free_login),
        content: t('cascadeBranchOverview.loginNoPermission'),
        disabled: () => !permissions.includes(PermissionsState.Password_free_login),
        opt: { size: 'small', type: 'text' as const }
      },
      {
        name: t('cascadeBranchOverview.unbind'),
        type: 'unbind',
        opt: { size: 'small', type: 'text' as const }
      }
    ]
  }
})

async function loadTree() {
  loadingTreeData.value = true
  const res = await cascadeService
    .getTerminalInfoTeamTerminalList()
    .catch(() => ({ datas: [] as TeamTerminal[] }))
    .finally(() => {
      loadingTreeData.value = false
    })
  const datas = (res as { datas?: TeamTerminal[] }).datas || []
  treeData.value = handleDataToTree(datas, 'team_id', 'parent_team_id')
  emit('refreshed')
}

function openAccessCodeDialog() {
  cascadeService.getCascadeAccessCode().then(({ access_code: code }) => {
    accessCode.value = code || ''
    accessVisible.value = true
  })
}

function copyAccessCode() {
  if (!accessCode.value) return
  useCopy(accessCode.value)
  if (copyAccessSuccessTimer) {
    clearTimeout(copyAccessSuccessTimer)
    copyAccessSuccessTimer = null
  }
  copyAccessSuccess.value = true
  copyAccessSuccessTimer = setTimeout(() => {
    copyAccessSuccess.value = false
    copyAccessSuccessTimer = null
  }, COPY_ACCESS_SUCCESS_MS)
}

watch(accessVisible, visible => {
  if (!visible) {
    if (copyAccessSuccessTimer) {
      clearTimeout(copyAccessSuccessTimer)
      copyAccessSuccessTimer = null
    }
    copyAccessSuccess.value = false
  }
})

async function refreshAccessCode() {
  refreshAccessLoading.value = true
  try {
    const { access_code: code } = await cascadeService.getCascadeRefreshAccessCode()
    accessCode.value = code || ''
  } catch {
    ElMessage({ type: 'error', message: t('cascadeBranchOverview.refreshAccessCodeFail') })
  } finally {
    refreshAccessLoading.value = false
  }
}

async function handleTableAction({ type, rowItem }: { type: string; rowItem?: RowAction }) {
  const row = rowItem
  if (!row) return
  if (type === 'edit') {
    router.push({ name: 'cascade-manage' })
    return
  }
  if (type === 'login') {
    cascadeLoginService.cascadeLogin({
      ip_addr: row.child_ip_addr!,
      server_port: row.child_server_port!,
      access_code: row.access_code,
      child_team_id: row.team_id,
      child_team_name: row.name,
      parent_team_id: team.getCurrentTeam().team_id,
      parent_token: user.getUserInfo().token
    })
    return
  }
  if (type === 'unbind') {
    try {
      await ElMessageBox.confirm(t('cascadeBranchOverview.unbindConfirm'), t('cascadeBranchOverview.tip'), {
        confirmButtonText: t('cascadeBranchOverview.confirm'),
        cancelButtonText: t('cascadeBranchOverview.cancel')
      })
    } catch {
      return
    }
    const ok = await cascadeService
      .getCascadeUnbind({ cascade_relation_id: row.cascade_relation_id })
      .then(() => true)
      .catch(() => false)
    ElMessage({
      type: ok ? 'success' : 'error',
      message: ok ? t('cascadeBranchOverview.unbindOk') : t('cascadeBranchOverview.unbindFail')
    })
    if (ok) loadTree()
  }
}

onMounted(() => {
  loadTree()
})

onUnmounted(() => {
  if (copyAccessSuccessTimer) {
    clearTimeout(copyAccessSuccessTimer)
    copyAccessSuccessTimer = null
  }
})

__expose({ refresh: loadTree })

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(Card, {
      size: "second",
      title: __props.title,
      "body-style": { padding: '0 0 16px' }
    }, {
      headerRight: _withCtx(() => [
        _createVNode(_component_el_tooltip, {
          effect: "light",
          content: accessKeyTooltip.value,
          placement: "top"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: openAccessCodeDialog
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getAccessKeyText.value), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_CmSvgIcon, {
                name: "views/dashboard/cascade-center/cascade-manage/assets/images/info-auth",
                width: "14",
                height: "14",
                class: "cm-ui-ml5",
                monochrome: ""
              })
            ])
          ]),
          _: 1
        }, 8, ["content"])
      ]),
      default: _withCtx(() => [
        _createVNode(CmTable, {
          ref_key: "tableRef",
          ref: tableRef,
          data: treeData.value,
          "onUpdate:data": _cache[0] || (_cache[0] = ($event: any) => ((treeData).value = $event)),
          "table-opt": tableOpt,
          "table-act-opt": tableActOpt,
          modelValue: queryStub,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryStub) = $event)),
          "has-permission": true,
          "first-loading": false,
          "page-option": { pageNumName: 'pageNum', pageSizeName: 'pageSize' },
          "card-opt": { style: { height: '100%', border: 'none' } },
          onHandleAction: handleTableAction
        }, {
          terminalInfo: _withCtx(({ row }) => [
            _createElementVNode("ul", _hoisted_2, [
              _createElementVNode("li", null, [
                _createTextVNode(_toDisplayString(_unref(terminalInfo).linux_num) + " ", 1),
                _createElementVNode("span", null, _toDisplayString(row.linux_num) + " " + _toDisplayString(unit.value), 1)
              ]),
              _createElementVNode("li", null, [
                _createTextVNode(_toDisplayString(_unref(terminalInfo).windows_num) + " ", 1),
                _createElementVNode("span", null, _toDisplayString(row.windows_num) + " " + _toDisplayString(unit.value), 1)
              ]),
              _createElementVNode("li", null, [
                _createTextVNode(_toDisplayString(_unref(terminalInfo).windows_server_num) + " ", 1),
                _createElementVNode("span", null, _toDisplayString(row.windows_server_num) + " " + _toDisplayString(unit.value), 1)
              ])
            ])
          ]),
          "auth_service_infos-header": _withCtx(({ label }) => [
            _createElementVNode("span", _hoisted_3, [
              _createTextVNode(_toDisplayString(label) + " ", 1),
              _createVNode(_component_el_tooltip, {
                effect: "light",
                content: authDetailTooltip.value,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("i", null, [
                    _createVNode(_component_CmSvgIcon, {
                      name: "views/dashboard/cascade-center/cascade-manage/assets/images/info-auth",
                      width: "14",
                      height: "14",
                      class: "cm-ui-ml5",
                      monochrome: ""
                    })
                  ])
                ]),
                _: 1
              }, 8, ["content"])
            ])
          ]),
          auth_service_infos: _withCtx(({ row }) => [
            _createVNode(_component_el_popover, {
              placement: "left",
              trigger: "hover",
              width: 200,
              disabled: !row.auth_service_infos || row.auth_service_infos.length <= 2
            }, {
              reference: _withCtx(() => [
                (row?.auth_service_infos?.length)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.auth_service_infos.slice(0, 3), (item, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, [
                          _createTextVNode(_toDisplayString(item.name) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(item.count) + " " + _toDisplayString(unit.value), 1)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_5, "--"))
              ]),
              default: _withCtx(() => [
                _createElementVNode("ul", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.auth_service_infos, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, [
                      _createTextVNode(_toDisplayString(item.name) + " ", 1),
                      _createElementVNode("span", null, _toDisplayString(item.count) + " " + _toDisplayString(unit.value), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _: 2
            }, 1032, ["disabled"])
          ]),
          _: 1
        }, 8, ["data", "table-opt", "table-act-opt", "modelValue"])
      ]),
      _: 1
    }, 8, ["title"])), [
      [_directive_loading, loadingTreeData.value]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: accessVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((accessVisible).value = $event)),
      title: getAccessKeyText.value,
      width: "400px",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createTextVNode(_toDisplayString(accessCode.value), 1),
          _createVNode(_component_el_tooltip, {
            effect: "light",
            content: copyTooltipContent.value,
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "access-code-copy-btn cm-ui-ml10",
                type: "primary",
                plain: "",
                size: "mini",
                onClick: copyAccessCode
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_8, [
                    _createVNode(_Transition, {
                      name: "copy-icon",
                      mode: "out-in"
                    }, {
                      default: _withCtx(() => [
                        (!copyAccessSuccess.value)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_14))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["content"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            loading: refreshAccessLoading.value,
            onClick: refreshAccessCode
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(regenerateAccessKeyText.value), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})